// eslint-disable-next-line import/prefer-default-export
export function onlyNumbers(value) {
  if (!value) {
    return null;
  }
  return value.match(/\d+/g).join('');
}
